import { ClerkProvider } from "@clerk/nextjs";
import { type PropsWithChildren, memo } from "react";

import { ClerkErrorBoundary } from "@/components/auth/ClerkErrorBoundary";
import { RouteConfig } from "@/config/route.config";
import { AuthContext } from "@/data/auth/auth.context";
import { useClerkErrorHandler } from "@/hooks/useClerkErrorHandler";

export const AuthClerkProvider = memo(({ children }: PropsWithChildren) => {
  const { handleClerkError } = useClerkErrorHandler();

  return (
    <ClerkProvider
      signInForceRedirectUrl="/postsso"
      signUpForceRedirectUrl="/postsso"
      afterSignOutUrl={RouteConfig.Signin}
      publishableKey={process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY}
    >
      <ClerkErrorBoundary onError={(error) => handleClerkError(error, "AuthClerkProvider")}>
        <AuthContext.Provider shouldPerformSync>{children}</AuthContext.Provider>
      </ClerkErrorBoundary>
    </ClerkProvider>
  );
});
